import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';

/**
 * Evita ResponsiveContainer en 0×0 al volver de otra ruta (Recharts no repinta solo).
 */
const ResponsiveChartBox = ({ height, className = '', minWidth = 1, children }) => {
  const ref = useRef(null);
  const [box, setBox] = useState({ width: 0, height });

  useEffect(() => {
    setBox((prev) => ({ ...prev, height }));
  }, [height]);

  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return;

    const measure = () => {
      const { width } = el.getBoundingClientRect();
      if (width >= minWidth) {
        setBox((prev) => (prev.width === width ? prev : { ...prev, width }));
      }
    };

    measure();
    const raf1 = requestAnimationFrame(() => {
      measure();
      requestAnimationFrame(measure);
    });

    const ro = new ResizeObserver(() => measure());
    ro.observe(el);
    window.addEventListener('resize', measure);

    const t = window.setTimeout(measure, 120);

    return () => {
      cancelAnimationFrame(raf1);
      window.clearTimeout(t);
      ro.disconnect();
      window.removeEventListener('resize', measure);
    };
  }, [minWidth, height]);

  return (
    <div
      ref={ref}
      className={className}
      style={{ width: '100%', height, minHeight: height, minWidth: 0 }}
    >
      {box.width > 0 ? children(box.width, box.height) : (
        <div className="w-full h-full animate-pulse rounded-lg bg-black/5 dark:bg-white/5" aria-hidden />
      )}
    </div>
  );
};

export default ResponsiveChartBox;
